import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { ShareEmailDialog } from "../../-components/share-email-dialog"
import { bulkIdsSearchSchema, emailsSearchSchema } from "../-lib/search"
import { useEmailsSelectionContext } from "../route"

export const Route = createFileRoute(
  "/_layout/quoting_/emails/_list/share/bulk",
)({
  component: ShareEmailsBulkModal,
  validateSearch: (search) => bulkIdsSearchSchema.parse(search),
  beforeLoad: async ({ context: { queryClient }, search }) => {
    await requirePermission(queryClient, "email:update", "/")
    if (search.ids.length === 0) {
      throw redirect({ to: "/quoting/emails", search: true })
    }
  },
})

function ShareEmailsBulkModal(): React.ReactElement {
  const { ids } = Route.useSearch()
  const navigate = useNavigate()
  const { clearEmailSelection } = useEmailsSelectionContext()

  return (
    <ShareEmailDialog
      emailIds={ids}
      onClose={() =>
        navigate({
          to: "/quoting/emails",
          search: (previous) => emailsSearchSchema.parse(previous),
        })
      }
      onShared={clearEmailSelection}
    />
  )
}
